import _ from 'lodash';
import React from 'react';
import PropTypes from 'prop-types';
import {createSelector} from 'reselect';
import {push} from 'react-router-redux';

import * as styles from '../../styles';
import {request} from '../../containers/actions';
import {refresh as paginatorRefresh, updateItem} from '../../paginator/actions';
import PaginatedContainer from '../../paginator/paginated_container';


export default class Pages extends React.PureComponent {
    static contextTypes = {
        store: PropTypes.object,
    }

    static propTypes = {
        readonly: PropTypes.bool,
        selectable: PropTypes.bool,
        actions: PropTypes.array,
        buttonActions: PropTypes.array,
    }

    static defaultProps = {
        readonly: false,
        selectable: true,
        actions: [],
        buttonActions: [],
    }

    listFields = [
        {field: 'id', label: window.gettext('ID')},
        {field: 'title', label: window.gettext('Title')},
        {
            label: window.gettext('Published'),
            field: 'published',
        },
        {
            field: item => <button
                style={{
                    ...styles.button,
                    backgroundColor: 'transparent',
                    padding: '.5em',
                    boxSizing: 'border-box',
                    minWidth: undefined,
                }}
                onClick={async event => {
                    event.stopPropagation();
                    let order = prompt(window.gettext('Enter Menu Order:')).english();
                    if (order !== '' && String(Number(order)) !== order)
                        return;
                    if (order === '')
                        order = null;
                    const response = await this.context.store.dispatch(request({
                        path: `/content/${item.id}/`,
                        body: {order},
                        method: 'PATCH',
                    }));
                    this.context.store.dispatch(updateItem(response, this.props.store.getIn(['paginator', 'elementId'])));
                }}
                onMouseUp={({target}) => target.blur()}>
                {(item.order || '-').persian()}
            </button>,
            label: window.gettext('Menu Order'),
        },
        {
            field: item => <a
                href={item.uri}
                style={{direction: 'ltr', textAlign: 'left', display: 'block'}}
                onClick={event => {
                    event.stopPropagation();
                    event.preventDefault();
                    this.context.store.dispatch(push(item.uri));
                }}>
                {item.uri}
            </a>,
            label: window.gettext('Address'),
        },
    ]

    filters = [
        {field: 'minimal', selected: {True: null}},
    ]

    booleanProperties = [
        {
            label: window.gettext('Published'),
            field: 'published',
        },
    ]

    actionsSelector = createSelector(
        [
            () => this.props.actions,
            () => this.props.readonly,
            () => this.props.store.getIn(['paginator', 'selected']).size > 0,
        ],
        () => this.props.readonly
            ? this.props.actions
            : _.concat(
                this.props.actions,
                this.props.store.getIn(['paginator', 'selected']).size > 0
                    ? [
                        {
                            label: window.gettext('Mass Edit'),
                            action: () => this.context.store.dispatch(push(
                                this.context.store.getState().getIn(
                                    ['routing', 'locationBeforeTransitions', 'pathname'],
                                ) + this.props.store.getIn(['paginator', 'selected']).keySeq().join(',') + '/',
                            )),
                        },
                    ]
                    : [],
            ),
    )

    sorts = [
        {name: 'id', label: window.gettext('ID'), reversed: true},
    ]

    componentDidUpdate(prevProps) {
        if (prevProps.params.id && !this.props.params.id) {
            this.context.store.dispatch(paginatorRefresh(this.props.store.getIn(['paginator', 'elementId'])));
        }
    }

    render() {
        return <PaginatedContainer
            store={this.props.store.get('paginator')}
            resource='content'
            listFields={this.listFields}
            title={window.gettext('Pages')}
            filters={this.filters}
            booleanProperties={this.booleanProperties}
            selectable={this.props.selectable}
            events={this.events}
            sorts={this.sorts}
            pageSize={this.props.pageSize}
            actions={this.actionsSelector(this.props.store)}
            active={this.props.params.id}
        />;
    }
}
